var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}]},[_vm._l((_vm.blok.body),function(item){return [_c(item.component,{key:item._uid,tag:"component",attrs:{"blok":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }